export default function (ref: HTMLElement | null): ref is HTMLElement {
  return ref !== undefined && ref !== null
}
